import { useWebVoiceContext } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/WebVoiceContext.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { defineMessages, useIntl } from 'react-intl';
const messages = defineMessages({
    voiceMode: {
        defaultMessage: 'Use voice mode',
        description: 'Aria label for the voice-to-voice mode button',
        id: 'd78b09e46d',
    },
    endVoice: {
        defaultMessage: 'End voice',
        id: '99c759faec',
        description: 'End the active voice session',
    },
});
export function useWebVoiceAction({ fallback }) {
    const webVoice = useWebVoiceContext();
    const { $t } = useIntl();
    const isActive = webVoice?.isActive ?? false;
    return {
        isActive,
        onPress: webVoice ? (isActive ? webVoice.close : webVoice.open) : fallback,
        label: $t(isActive ? messages.endVoice : messages.voiceMode),
        icon: isActive ? $icon('player-stop-filled') : $icon('custom-perplexity-v2v'),
    };
}
//# sourceMappingURL=useWebVoiceAction.js.map